import { Outlet, Navigate, useResolvedPath } from 'react-router-dom';
import { URLS } from '.';
import { useAuthStatus, useUserSelector } from '../store/selectors/userSelector';
import { useEffect, useState } from 'react';

const PrivateRoutes = () => {
    const isAuth = useAuthStatus();
    return (
        isAuth ? <Outlet /> : <Navigate to={URLS.AUTH.LOGIN} />
    )
}

export default PrivateRoutes;